import { motion } from 'framer-motion';
import { CATEGORIES } from '../../../constants/onboarding';

const InterestsStep = ({ formData, onInputChange, onNext, onBack, isValid }) => {
  const handleCategoryToggle = (category) => {
    const currentCategories = formData.interests.categories;
    const newCategories = currentCategories.includes(category)
      ? currentCategories.filter(c => c !== category)
      : [...currentCategories, category];
    
    onInputChange('interests', 'categories', newCategories);
  };

  const categoryInfo = {
    PRODUCTIVITY: {
      emoji: '⚡️',
      description: 'Boost your efficiency'
    },
    WELLNESS: {
      emoji: '🧘‍♂️',
      description: 'Take care of yourself'
    },
    GROWTH: {
      emoji: '🌱',
      description: 'Grow as a person'
    },
    FINANCE: {
      emoji: '💰',
      description: 'Manage your finances'
    },
    SOCIAL: {
      emoji: '🤝',
      description: 'Build relationships'
    },
    MINDFULNESS: {
      emoji: '🎯',
      description: 'Stay focused'
    }
  };

  return (
    <motion.div
      className="onboarding-step interests-step"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
    >
      <div className="interests-content">
        <div className="interests-header">
          <h2>Your Focus Areas</h2>
          <p className="step-description">
            Select what matters to you
          </p>
        </div>

        <motion.div 
          className="interests-grid"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          {Object.entries(categoryInfo).map(([key, { emoji, description }], index) => (
            <motion.button
              key={key}
              className={`interest-card ${formData.interests.categories.includes(CATEGORIES[key]) ? 'active' : ''}`}
              onClick={() => handleCategoryToggle(CATEGORIES[key])}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * (index + 1) }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <span className="interest-emoji">{emoji}</span>
              <span className="interest-name">{key.charAt(0) + key.slice(1).toLowerCase()}</span>
              <span className="interest-description">{description}</span>
            </motion.button>
          ))}
        </motion.div>

        <div className="step-buttons">
          <button 
            className="onboarding-btn secondary"
            onClick={onBack}
          >
            Back
          </button>
          <button 
            className="onboarding-btn"
            onClick={onNext}
            disabled={!isValid}
          >
            Continue
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default InterestsStep; 